let paginationActions = {
    applyPagination: function(data) {
        return (dispatch, getState)=>{
            return new Promise((resolve, reject)=>{
                dispatch({type: 'APPLY_PAGINATION', data});
                resolve(data);
            });
        };
    }
};

export default paginationActions;
